import React from 'react';
import clsx from 'clsx';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y } from 'swiper/modules';
import RotatingVideo from '../../../../../video/rotating-background.mp4';

import Container from '@common/Container';
import Heading from '@common/Heading';
import Section from '@common/Section';
import Row from '@common/Row';
import Img from '@common/Image';
import Link from '@common/Link';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

import * as styles from './links-rotating-background.module.scss';

const LinksRotatingBackground = ({ data }) => {

  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  return (
    <Section className={clsx('overflow-hidden', {[`bg-${bgColour} py-5`]: bgColour })}>
      <div className='d-flex justify-content-center position-relative'>
        <Container style={{zIndex: 2}}>
          {(showTitle && title) && <Heading type='h2' className='mx-auto mt-7 mb-2 text-center text-white position-relative'>{title}</Heading>}
          <Row className='justify-content-between mb-7'>
            {list &&
              <Swiper
                className='show-overflow'
                modules={[A11y]}
                slidesPerView={1.5}
                spaceBetween={20}
                breakpoints={{
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 20
                },
                992: {
                  slidesPerView: 2.5,
                  spaceBetween: 20
                },
                768: {
                  slidesPerView: 1.75,
                  spaceBetween: 20
                }
                }}>
                {list.map((card, index) => (
                  <SwiperSlide key={index} className='d-flex' style={{minHeight: 495}}>
                    <Link to={card.link} className={clsx('d-flex flex-column align-self-lg-center space-between text-black text-center rounded py-5 px-4 px-xl-2 no-hover', styles.card, {[`bg-card-${card.bgColour}`]: card.bgColour})}>
                      {card.image &&
                        <div className='position-relative mb-3 rounded'>
                          <Img
                            placeholder='blurred'
                            image={card.image.gatsbyImageData}
                            file={card.image.file}
                            alt={card.image.description}
                            height='60px'
                            width='60px'
                          />
                        </div>
                      }
                      {card.title && <Heading type='h3'>{card.title}</Heading>}
                      <div className={styles.cardText}>
                        {card.subtitle && <p className='mb-3'>{card.subtitle}</p>}
                        {card.linkCopy &&
                          <div className='d-flex justify-content-center align-items-center'>
                            <p className='mb-0'>{card.linkCopy}</p>
                            <FontAwesomeIcon icon={faArrowRight} style={{marginLeft: 5}} />
                          </div>
                        }
                      </div>
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            }
          </Row>
        </Container>
        {/* Background video loop */}
        <video autoPlay loop muted playsInline className='position-absolute w-100' style={{zIndex: 1, backgroundColor: 'transparent'}}>
          <source src={RotatingVideo} type='video/mp4'/>
        </video>
      </div>
    </Section>
  )
}

export default LinksRotatingBackground
